export const HIT_FOR_TURN = 2;

// колличество ударов в одном раунде (по гдд 12, по  6 бросков на игрока)
export const HIT_FOR_ROUND = 6;
export const ROUNDS_TOTAL = 2;

